import { render, staticRenderFns } from "./CopyToReportingPreferences.vue?vue&type=template&id=2574f4d3&scoped=true"
import script from "./CopyToReportingPreferences.vue?vue&type=script&lang=js"
export * from "./CopyToReportingPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574f4d3",
  null
  
)

export default component.exports